module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drug-button btn drug-button-by-med",
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "padding": "1.5rem 0"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('refillNewDrugStorage')
      }
    }
  }, [_c('span', [_vm._v("無相同批號？補藥至新的藥盒")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-274b0060","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/RefillToNewDrugStorage.vue
// module id = 1414
// module chunks = 1